import { useDispatch } from 'react-redux'

import { reset } from 'features/user'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { SIGN_OUT } from './api/mutation'

import type { Data, Variables } from './api/types'
import type { UseSignOut } from './types'
import type { AppDispatch } from 'providers/redux'

export const useSignOut = (): UseSignOut => {
  const dispatch: AppDispatch = useDispatch()

  const { isPending, mutateAsync } = useMutation<Variables, Data>({
    mutation: SIGN_OUT,
    onCompleted: async () => {
      dispatch(reset())
    },
  })

  const signOut = (): void => {
    void mutateAsync({})
  }

  return {
    loading: isPending,
    signOut,
  }
}
